import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import LogoutIcon from "@mui/icons-material/Logout";
import HistoryIcon from "@mui/icons-material/History";
import { isMobile } from "react-device-detect";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "./sidebar.css";

const SidebarComponent = ({ logOut, isModalVisible, toggleSidebar }) => {
  const firstName = localStorage.getItem("firstName");
  const lastName = localStorage.getItem("lastName");
  const initials = `${firstName ? firstName[0] : ""}${
    lastName ? lastName[0] : ""
  }`.toUpperCase();

  const renderSideBar = () => {
    if (isMobile) {
      return (
        <>
          <div
            className="hf-nav-backdrop"
            onClick={toggleSidebar}
            aria-hidden="true"
          />
          <div className="hf-nav-drawer">
            <div className="hf-nav-header">
              <div className="hf-nav-logo">
                <img src="img/hitfitlogo.jpg" alt="HitFit" />
              </div>
              <button
                type="button"
                className="hf-nav-close"
                aria-label="Zatvori meni"
                onClick={toggleSidebar}
              >
                <CloseIcon fontSize="small" />
              </button>
            </div>

            <div className="hf-nav-profile">
              <div className="hf-nav-avatar">{initials || "?"}</div>
              <div className="hf-nav-name">
                {firstName} {lastName}
              </div>
            </div>

            <ul className="hf-nav-menu">
              <li className="hf-nav-menu-item">
                <EditIcon />
                Uredi profil
              </li>
              <li
                className="hf-nav-menu-item"
                onClick={() => (window.location.href = "/my-bookings")}
              >
                <CalendarMonthIcon />
                Moji termini
              </li>
              <li
                className="hf-nav-menu-item hf-nav-danger"
                onClick={logOut}
              >
                <LogoutIcon />
                Odjavi se
              </li>
            </ul>
          </div>
        </>
      );
    }

    return (
      <div className="sidebar">
        <div className="profile-section">
          <h2 className="user-name">
            {firstName} {lastName}
          </h2>
        </div>
        <ul className="menu">
          <div className="sidebar-icons-div">
            <EditIcon />
            <li
              className="menu-item"
              onClick={() => console.log("Edit Profile")}
            >
              Uredi profil
            </li>
          </div>
          <div className="sidebar-icons-div">
            <HistoryIcon />

            <li
              className="menu-item"
              onClick={() => (window.location.href = "/my-bookings")}
            >
              Moja zakazivanja
            </li>
          </div>
          <div className="sidebar-icons-div">
            <LogoutIcon />
            <li className="menu-item" onClick={logOut}>
              Odjavi se
            </li>
          </div>
        </ul>
      </div>
    );
  };

  return renderSideBar();
};

export default SidebarComponent;
